{
  "qr-checkin-success-page": {
    "buttons": {
      "book-now": "ĐẶT LỊCH NGAY",
      "find-salon": "TÌM TIỆM",
      "salon-page": "TRANG ĐẶT LỊCH CỦA TIỆM"
    },
    "text": {
      "checked-in": "Check in thành công!",
      "checked-in-hint": "Bạn có thể đặt lịch hẹn mới cho lần tiếp theo bất cứ lúc nào"
    },
    "meta": {
      "title": "QR Checkin",
      "description": "Checkin qua mã QR"
    }
  }
}
